import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Ophthalmologist icon
 *
 * @category Medical
 */
const Ophthalmologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M25.683 23.53c-.51-.61-2.87-1.09-3.32-1.68-.31-.35-.17-.77-.06-1.2.95-2.99.84-7.23-.07-10.28-.19-1.36 1.95-1.37 2.98-2.05.69-.34.81-1.01-.17-.89-.67.12-1.45.49-2.12.72-1.28.58-2.01-.13-2.62-1.12-.16-.72.92-1.05 1.38-1.44 1.13-.63 1.02-1.73.03-1.21-4.93 3.26-12.38 7.47-17.16 10.95-.15.3-.14.67.14.87.47.32 1.63 1.03 3.15 2 4.18 2.64 10.19 6.46 14.02 8.86.4.3 1.18-.2.16-1.04-1.28-.99-2.7-1.29-.79-2.74 1.02-.66 2.8.79 3.95.84.5.03.7-.22.54-.51l-.06-.09zm-3.79-7.66c-.07 1.74-.17 3.79-.89 5.24-.57.69-1.56-.07-2.26-.29-1.03-.5-2.28-.69-2.54-1.82-.37-2.18-.57-5.01.19-7.05.78-.96 2.33-1.19 3.43-1.74 2.18-1.04 1.92 4.3 2.06 5.48v.18zm-6.82 3.2c-2.56-.53-5.63-2.19-8.14-3.13-.23-.11-.67-.28-.3-.48 1.45-.52 6.43-2.7 8.32-3.18.28.08.25.45.25.73-.18 1.78-.17 3.76.03 5.55 0 .21-.02.37-.1.45l-.07.05zm5.44-9.88c-.85.38-2.24.91-3.19 1.26-.26.09-.5.12-.58-.02-.1-.89.83-2.19 1.57-2.61.94-.58 2.02.35 2.26 1.3zm-4.41.24c-.2 2.13-2.11 2.16-4.17 3.1-.712.275-1.392.55-1.83.719-.264.101-.297.027-.063-.133a179 179 0 0 1 5.503-3.586c.13-.06.46-.29.55-.17l.02.06zm-3.4 9.74c1.49.72 2.73.66 3.24 2.12.22.58.24.89-.12.68-1.25-.788-3.523-2.228-5.083-3.288-.186-.126-.072-.344.136-.26.634.256 1.354.561 1.827.748m6.93 4.3c-1.18.78-2.25-.73-2.69-1.71-.16-.36-.35-.79-.23-.9.1-.09.39.07.7.18.93.38 2.02.77 2.85 1.15.45.36-.22.86-.52 1.19l-.12.08z"
        />
        <path
          fill="currentColor"
          d="M21.583 17.331a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7"
        />
      </svg>
    );
  }
);

Ophthalmologist.displayName = 'Ophthalmologist';

export { Ophthalmologist };
